export const selectPayoutTransactions = state => Object.values(state.payoutTransactions.items) || [];

export const selectPayoutTransactionsPaginate = state => state.payoutTransactions.paginate || {};

export const selectPayoutTransactionsLoading = state => state.payoutTransactions.isLoading;
